import React, { useEffect } from 'react';
import './servicesSettings.css';
import { useDispatch, useSelector } from "react-redux";
import { setServicesSettingsAction } from "../../redux/rootReducer";
import { GetServicesSettingsThunk } from "../../redux/thunks/GetServicesSettingsThunk";
import Masters from "../Masters/Masters";
import Specializations from "../Specializations/Specializations";
import Services from "../Services/Services";

const ServicesSettings = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);

    useEffect(() => {
        dispatch(GetServicesSettingsThunk());
    }, []);

    return (
        <div className="page__content">
            <div className="tabs">
                <div className={ `tab ${ services_settings.current_tab === 'masters' ? 'tab--active' : '' }` }
                    onClick={ () => {
                        if (services_settings.current_tab === 'masters') return;

                        dispatch(setServicesSettingsAction({
                            ...services_settings,
                            current_tab: 'masters'
                        }));
                    } }
                >Мастера</div>
                <div className={ `tab ${ services_settings.current_tab === 'specializations' ? 'tab--active' : '' }` }
                     onClick={ () => {
                         if (services_settings.current_tab === 'specializations') return;

                         dispatch(setServicesSettingsAction({
                             ...services_settings,
                             current_tab: 'specializations'
                         }));
                     } }
                >Специализации</div>
                <div className={ `tab ${ services_settings.current_tab === 'services' ? 'tab--active' : '' }` }
                     onClick={ () => {
                         if (services_settings.current_tab === 'services') return;

                         dispatch(setServicesSettingsAction({
                             ...services_settings,
                             current_tab: 'services'
                         }));
                     } }
                >Услуги</div>
            </div>
            {
                services_settings.current_tab === 'masters'
                ?
                    <Masters/>
                :
                services_settings.current_tab === 'specializations'
                ?
                    <Specializations/>
                :
                services_settings.current_tab === 'services'
                ?
                    <Services/>
                :
                    false

            }
        </div>
    );
};

export default ServicesSettings;